export default "__VITE_ASSET__f8ed071b__"